import { AccountHierarchyResponseTypeEnum } from '@monetize/types/app';
import {
  useGetAccountById,
  useGetAccountHierarchyById,
} from '../../api/accountsService';
import { AccountHierarchyTree } from '../../routes/Accounts/AccountHierarchy/AccountHierarchyTree';
import { MFlex, MSpinner, MText } from '../Monetize';

interface QuoteAccountHierarchyViewProps {
  accountId: string;
}

/**
 * Renders the account hierarchy tree inline (loading + empty states
 * included). Shared by the account-hierarchy modal and the quote offering
 * group drawer's "Account Hierarchy" tab.
 */
export const QuoteAccountHierarchyView = ({
  accountId,
}: QuoteAccountHierarchyViewProps) => {
  const { data: account } = useGetAccountById(accountId, {
    enabled: !!accountId,
  });
  const { data: accountHierarchy, isLoading } = useGetAccountHierarchyById(
    account?.rootAccountId || account?.id || '',
    AccountHierarchyResponseTypeEnum.NESTED,
    {
      enabled: !!account?.rootAccountId || !!account?.id,
    },
  );

  if (isLoading) {
    return (
      <MFlex justify="center" align="center" py={8}>
        <MSpinner size="sm" />
      </MFlex>
    );
  }

  if (!accountHierarchy || !account) {
    return (
      <MText color="fg.muted" fontSize="sm" py={4} textAlign="center">
        No account hierarchy available.
      </MText>
    );
  }

  return (
    <AccountHierarchyTree
      hierarchy={accountHierarchy}
      currentAccountId={account.id}
    />
  );
};
